import React, { useState, useEffect } from 'react';
import { MainContainer } from '../../Home/HomeStyles';
import styled from 'styled-components';

const styles = {
  container: {
    maxWidth: '1200px',
    marginLeft: '0',
    padding: '20px',
    fontFamily: 'Arial, sans-serif',
    textAlign:'left'
  },
  title: {
    fontSize: '1.5rem',
    fontWeight: 'bold',
    marginBottom: '20px',
    color: '#333',
  },
  inputContainer: {
    display: 'flex',
    gap: '10px',
    marginBottom: '20px',
  },
  input: {
    padding: '10px',
    border: '1px solid #ddd',
    borderRadius: '4px',
    flex: '1',
  },
  button: {
    padding: '10px 20px',
    backgroundColor: '#3498db',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    transition: 'background-color 0.3s',
  },
  balance: {
    marginBottom: '20px',
    fontSize: '1.2rem',
    fontWeight: 'bold',
  },
  message: {
    marginTop: '10px',
    color: 'green',
  },
};

export default function PointDeposit() {
  const [amount, setAmount] = useState('');
  const [pointsBalance, setPointsBalance] = useState(0);
  const [message, setMessage] = useState('');
  const [withdrawHistory, setWithdrawHistory] = useState([]); // 출금 내역 상태 추가
// Pagination state variables
const [currentPage, setCurrentPage] = useState(1);
const [totalPages, setTotalPages] = useState(1);
const [totalRecords, setTotalRecords] = useState(0);
const [limit, setLimit] = useState(10); // Number of records per page
useEffect(() => {
  fetchPointsBalance();
  fetchWithdrawHistory(currentPage);
}, []);

useEffect(() => {
  fetchWithdrawHistory(currentPage); // Fetch data when page changes
}, [currentPage]);

useEffect(() => {
  fetchWithdrawHistory(1); // Reset to first page when limit changes
}, [limit]);

  const fetchPointsBalance = async () => {
    try {
      const response = await fetch('/Acution/points-balance', {
        credentials: 'include',
      });
      const data = await response.json();
      if (data.points_balance !== undefined) {
        setPointsBalance(data.points_balance);
      } else {
        console.error('포인트 잔액을 가져올 수 없습니다.');
      }
    } catch (error) {
      console.error('포인트 잔액 조회 중 오류 발생:', error);
    }
  };

  const fetchWithdrawHistory = async (page = currentPage) => {
    try {
      const response = await fetch(`/Acution/withdraw-history?page=${page}&limit=${limit}`, {
        credentials: 'include',
      });
      const data = await response.json();
      if (response.ok) {
        setWithdrawHistory(data.withdrawHistory);
        setTotalPages(data.totalPages);
        setCurrentPage(data.currentPage);
        setTotalRecords(data.totalRecords);
      } else {
        console.error('출금 내역을 가져올 수 없습니다.');
      }
    } catch (error) {
      console.error('출금 내역 조회 중 오류 발생:', error);
    }
  };

  const handleWithdraw = async () => {
    if (!amount || parseInt(amount) <= 0) {
      setMessage('출금 금액을 올바르게 입력해주세요.');
      return;
    }

    if (parseInt(amount) > pointsBalance) {
      setMessage('포인트 잔액이 부족합니다.');
      return;
    }

    try {
      const response = await fetch('/Acution/withdraw-points', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ amount: parseInt(amount, 10) }),
      });
      const data = await response.json();
      if (response.ok) {
        setMessage(data.message);
        setPointsBalance((prevBalance) => prevBalance - parseInt(amount, 10));
        setAmount('');
        fetchWithdrawHistory(); // 출금 내역 갱신
      } else {
        setMessage(data.error);
      }
    } catch (error) {
      console.error('포인트 출금 중 오류 발생:', error);
      setMessage('포인트 출금 중 오류가 발생했습니다.');
    }
  };
  const formatAmount = (amount) => {
    return amount?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };
  return (
    <MainContainer>
      <div style={styles.container}>
        <h2 style={styles.title}>포인트 출금</h2>
        <div style={styles.balance}>현재 포인트 잔액: {pointsBalance?.toLocaleString()}점</div>
        <div style={styles.inputContainer}>
          <input
            style={styles.input}
            type="number"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            placeholder="출금할 포인트 금액 입력"
          />
          <button style={styles.button} onClick={handleWithdraw}>
            출금하기
          </button>
        </div>
        {message && <div style={styles.message}>{message}</div>}

        {/* 출금 내역 표시 */}
        <h3 style={{ ...styles.title, marginTop: '40px' }}>출금 내역</h3>
   
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th style={{ border: '1px solid #ddd', padding: '8px' }}>날짜</th>
              <th style={{ border: '1px solid #ddd', padding: '8px' }}>출금 금액</th>
              <th style={{ border: '1px solid #ddd', padding: '8px' }}>완료여부</th>
            </tr>
          </thead>
          <tbody>
            {withdrawHistory.length > 0 ? (
              withdrawHistory.map((entry, index) => (
                <tr key={index}>
                  <td style={{ border: '1px solid #ddd', padding: '8px' }}>{new Date(entry.requested_at)?.toLocaleString()}</td>
                  <td style={{ border: '1px solid #ddd', padding: '8px' }}>{formatAmount(entry.requested_amount)}점</td>
                  <td style={{ border: '1px solid #ddd', padding: '8px' }}>{entry.status==='withdrawal_comp'? '출금완료':'출금대기'}</td>
                  {/* //withdrawal_comp = 출금완료 */}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="2" style={{ textAlign: 'center', padding: '20px' }}>
                  출금 내역이 없습니다.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    
{/* Pagination Controls */}
<div style={{display:'flex',justifyContent:'space-between',padding:'0px 20px'}}>
  <div style={{ marginTop: '20px', textAlign: 'center' }}>
    <button
      onClick={() => handlePageChange(currentPage - 1)}
      disabled={currentPage === 1}
      style={{ marginRight: '10px' }}
    >
      이전
    </button>
    <span style={{padding:'10px'}}>
      {currentPage} / {totalPages}
    </span>
    <button
      onClick={() => handlePageChange(currentPage + 1)}
      disabled={currentPage === totalPages}
      style={{ marginLeft: '10px' }}
    >
      다음
    </button>
  </div>
  <div style={{ marginTop: '20px', textAlign: 'center' }}>
    <label>
      페이지당 표시할 항목 수:{' '}
      <select
        value={limit}
        onChange={(e) => setLimit(parseInt(e.target.value, 10))}
      >
        <option value={5}>5</option>
        <option value={10}>10</option>
        <option value={20}>20</option>
      </select>
    </label>
  </div>
</div>

    </MainContainer>
  );
}
